import React from "react";
import { ArrowPathIcon, MapPinIcon } from "@heroicons/react/24/outline";
import V2ListBoxPageSize from "./v2_listbox_page_size";
import ComboboxAutocomplete from "./combobox_autocomplete";

export default function WorkingAreaPresenceContextBar({
  workingAreas = [],
  selectedWorkingArea = null,
  onWorkingAreaChange,
  pageSize = 25,
  onPageSizeChange,
  totalCount = 0,
}) {
  const options = [{id: "all", name: "Tutte le aree di lavoro", }, ...workingAreas,];
  const selectedValue = selectedWorkingArea || options[0];

  const handleAreaChange = (value) => {
    if (!value || value.id === "all") {
      onWorkingAreaChange?.(null);
      return;
    }

    onWorkingAreaChange?.(value);
  };

  const handleReset = () => {
    onWorkingAreaChange?.(null);
  };

  return (
    <section className="w-full rounded-xl border border-indigo-100 bg-white shadow-sm ring-1 ring-black/5">
      {/* Barra principale */}
      <div className="px-4 py-3 md:px-5">
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-[35%_35%_28%] lg:items-center">

          {/* Titolo */}
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-indigo-50 text-indigo-600">
              <MapPinIcon className="h-6 w-6" />
            </div>

            <div>
              <p className="text-xs font-semibold uppercase tracking-wide text-indigo-800">
                Presenze aree di lavoro
              </p>

              <p className="mt-0.5 text-xs text-gray-500">
                Situazione aggiornata delle presenze nelle aree
              </p>
            </div>
          </div>

          {/* Area di lavoro */}
          <div className="w-full">
            <ComboboxAutocomplete
              options={options}
              value={selectedValue}
              onChange={handleAreaChange}
              placeholder="Seleziona area di lavoro..."
              bgActiveColor="bg-indigo-100"
              textActiveColor="text-gray-700"
              borderClass="border-gray-300 rounded-lg"
              borderInput="rounded-lg"
              pyClass="py-2.5"
              zIndex="z-40"
              alwaysFirstIds={["all"]}
              displayValue={(element) => element?.name || ""}
            />
          </div>

          {/* Reset */}
          <div className="flex justify-start lg:justify-end">
            {selectedWorkingArea && (
              <button
                type="button"
                onClick={handleReset}
                className="inline-flex h-9 items-center gap-1.5 whitespace-nowrap rounded-lg border border-gray-200 bg-white px-3 text-xs font-semibold text-gray-600 shadow-sm transition-colors hover:border-indigo-200 hover:bg-indigo-50 hover:text-indigo-700"
              >
                <ArrowPathIcon className="h-4 w-4" />
                Reset selezione
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="border-t border-gray-100 bg-gray-50 px-4 py-2.5 md:px-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-gray-500">
            <span className="font-semibold text-gray-700">{totalCount}</span>{" "}
            {totalCount === 1 ? "area visualizzata" : "aree visualizzate"}
          </p>

          <V2ListBoxPageSize
            value={pageSize}
            onChange={onPageSizeChange}
          />
        </div>
      </div>
    </section>
  );
}